




























import Vue from "vue";
import AppCheckbox from "@/components/AppCheckbox.vue";
import { AppAnalytics } from "@/analytics";
export default Vue.extend({
  components: {
    AppCheckbox,
  },
  props: ["value"],
  methods: {
    privacyPolicy() {
      AppAnalytics.report({
        eventName: `Onboarding_click on privacy policy  (${this.$route.name} page)`,
      });
      window.open(
        "https://docs.cognni.ai/en/articles/8053160-privacy-policy",
        "_blank"
      );
    },
    termsOfUse() {
      AppAnalytics.report({
        eventName: `Onboarding_click on terms of use  (${this.$route.name} page)`,
      });
      window.open(
        "https://docs.cognni.ai/en/articles/8053155-end-user-agreement-and-terms-of-service",
        "_blank"
      );
    },
    onCheckChange(isChecked: boolean) {
      this.$emit("input", isChecked);
      if (isChecked) {
        AppAnalytics.report({
          eventName: `Onboarding_checked privacy policy and terms of use (${this.$route.name} page)`,
        });
      }
    },
  },
});
